import RedirectPage from '@/redirectshandler/redirect-page'; 

export default RedirectPage;

// No next-intl on this route; _app still requires pageProps.messages — see helpers/emptyPageStaticProps.js
export {getEmptyPageStaticProps as getStaticProps} from 'helpers/emptyPageStaticProps';
